import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
// import { ScopeCertificateDetails } from '../../../sc-models/scope-certificate-details-dto';
import {
  ICertifiedOrganizationDetails,
  initialCertifiedOrganizationDetails,
  mapCertifiedOrganizationDetailsApiResponseToInitialValues,
  mapPayload,
} from "../../../sc-models/certified-organization-details-dto";
import FormBuilder from "../../../../../shared/components/form-builder/form-builder";
import { useApi } from "../../../../../shared/hooks/useApi";
import { TCAppConfig } from "../../../../../shared/app-configs/tc-app-configs";
// import { API } from '../../../../shared/app-configs/sc-app-config';
import useNotification from "../../../../../shared/hooks/useNotification";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import { Box } from "@mui/material";
import { buyerSellerDetailsService } from "../../../../transaction-certificates/tc-service/buyer-seller-details.service";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import { API_ROUTES } from "../../../../../shared/app-configs/sc-app-config";
import { Utills } from "../../../../../shared/app-configs/utilit";
import { InnerButton } from "../../../../../shared/components/buttons/floating-button-container";
import { dtrackItService } from "../../../../transaction-certificates/tc-service/dtrackit.service";

interface CertifiedOrganizationDetailsProps {
  onNextTab: () => Promise<void>;
}

const CertifiedOrganizationDetails: React.FC<
  CertifiedOrganizationDetailsProps
> = ({ onNextTab }) => {
  const formRef = useRef<any>(null);
  const { loading, executeGet, setLoadingState, executePost } = useApi();

  const { notify } = useNotification();
  const navigate = useNavigate();
  const { formtype, SC_ID } = useParams();
  const hasCreateSC = formtype === "create-sc";
  const hasSubmitSC: boolean = formtype === "submited-sc";

  const [visible, setVisible] = useState({
    certifiedOrganizationTEId: true,
    certifiedOrganizationName: true,
    coTEIdLabel: true,
  });

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [disable, setDisable] = useState({
    address1: true,
    country: true,
    state: true,
    town: true,
    postcode: true,
  });

  const getCountry = async () => {
    try {
      const result = await dtrackItService.getCountry();
      const countries = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1}  (${t.code_1})`,
      }));
      setCountryOptions(countries);
    } catch (err) {
      notify("Failed to fetch countries", "error");
    }
  };

  const getState = async (countryCode: string) => {
    try {
      setIsLoadingStates(true);
      const result = await dtrackItService.getStateBasedonCountry(countryCode);
      const states = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1}  (${t.code_1})`,
      }));
      setStateOptions(states);
    } catch (err) {
      setStateOptions([]);
    } finally {
      setIsLoadingStates(false);
    }
  };

  const [initialValues, setInitialValues] =
    useState<ICertifiedOrganizationDetails>(
      initialCertifiedOrganizationDetails
    );

  const fetchCoDetails = async () => {
    try {
      const response: any = await executeGet(API_ROUTES.GET_CO_DETAILS, {
        scId: SC_ID,
      });
      Utills.cl("This is the response", response);
      const data: any =
        mapCertifiedOrganizationDetailsApiResponseToInitialValues(
          response.data
        );
      setInitialValues(data);

      // Move this check here to ensure it happens after data is loaded
      if (data.certifiedOrganizationTeId) {
        setVisible((prev) => ({
          ...prev,
          coTEIdLabel: false,
        }));
      }

      getState(data.certifiedOrganizationCountryOrArea);
    } catch (err) {
      Utills.cl("I am in catch block");
      console.error("Failed to fetch CO Base Details:", err);
    }
  };

  useEffect(() => {
    getCountry();
    if (SC_ID || !hasCreateSC) {
      fetchCoDetails();
    }
  }, [SC_ID]);

  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
      };
      const response = await buyerSellerDetailsService.getTEDetails(
        queryParams
      );
      const data = response.data;
      Utills.cl(
        `fetchTEDetallsFromAPI details, query ${JSON.stringify(
          queryParams
        )} response data ${JSON.stringify(data)}`
      );

      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error;
    }
  };

  const handleSellerTEIdValueChange = (value: any) => {
    const fields = [
      "certifiedOrganizationAddress1",
      "certifiedOrganizationTown",
      "certifiedOrganizationPostcode",
      "certifiedOrganizationStateOrProvince",
      "certifiedOrganizationCountryOrArea",
      "certifiedOrganizationName",
      "certifiedOrganizationTeId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        country: true,
        state: true,
      }));
      setVisible((prev) => ({
        ...prev,
        // certifiedOrganizationName: true,
        coTEIdLabel: true,
      }));
    } else {
      formRef.current.setFieldValue(
        "certifiedOrganizationName",
        value.account_name
      );
      formRef.current.setFieldValue("certifiedOrganizationTeId", value.TE_ID);
      // formRef.current.setFieldValue(
      //   "certifiedOrganizationAddress1",
      //   value.street
      // );
      formRef.current.setFieldValue("certifiedOrganizationTown", value.city);
      formRef.current.setFieldValue(
        "certifiedOrganizationPostcode",
        value.postal_code
      );

      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          country: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          country: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationCountryOrArea",
          value.country
        );
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          address1: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          address1: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationAddress1",
          value.street
        );
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          state: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          state: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationStateOrProvince",
          value.state
        );
      }

      // Handle postcode
      if (value.postal_code != null) {
        setDisable((prev) => ({
          ...prev,
          postcode: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationPostcode",
          value.postal_code
        );
      } else {
        setDisable((prev) => ({
          ...prev,
          postcode: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationPostcode", "");
      }

      // Handle town
      if (value.city != null) {
        setDisable((prev) => ({
          ...prev,
          town: true,
        }));
        formRef.current.setFieldValue("certifiedOrganizationTown", value.city);
      } else {
        setDisable((prev) => ({
          ...prev,
          town: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationTown", "");
      }

      setVisible((prev) => ({
        ...prev,
        // certifiedOrganizationName: false,
        coTEIdLabel: false,
      }));
    }
  };

  const handleSellerNameValueChange = (value: any) => {
    Utills.cl("I am in handleSellerNameValueChange");
    const fields = [
      "certifiedOrganizationAddress1",
      "certifiedOrganizationTown",
      "certifiedOrganizationPostcode",
      "certifiedOrganizationStateOrProvince",
      "certifiedOrganizationCountryOrArea",
      "certifiedOrganizationName",
      "certifiedOrganizationTeId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });

      setVisible((prev) => ({
        ...prev,
        certifiedOrganizationTEId: true,
      }));
      setDisable((prev) => ({
        ...prev,
        country: true,
        state: true,
      }));
    } else {
      formRef.current.setFieldValue(
        "certifiedOrganizationName",
        value.account_name
      );
      formRef.current.setFieldValue("certifiedOrganizationTeId", value.TE_ID);
      // formRef.current.setFieldValue(
      //   "certifiedOrganizationAddress1",
      //   value.street
      // );
      formRef.current.setFieldValue("certifiedOrganizationTown", value.city);
      formRef.current.setFieldValue(
        "certifiedOrganizationPostcode",
        value.postal_code
      );

      //handle certifiedOrganizationAddress1
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          address1: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          address1: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationAddress1",
          value.street
        );
      }

      // Handle country
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode);
        setDisable((prev) => ({
          ...prev,
          country: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationCountryOrArea",
          value.country
        );
      } else {
        setDisable((prev) => ({
          ...prev,
          country: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationCountryOrArea", "");
      }

      // Handle address1
      if (value.street != null) {
        setDisable((prev) => ({
          ...prev,
          address1: true,
        }));
        formRef.current.setFieldValue("certifiedOrganizationAddress1", value.street);
      } else {
        setDisable((prev) => ({
          ...prev,
          address1: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationAddress1", "");
      }

      // Handle state
      if (value.state != null) {
        setDisable((prev) => ({
          ...prev,
          state: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationStateOrProvince",
          value.state
        );
      } else {
        setDisable((prev) => ({
          ...prev,
          state: false,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationStateOrProvince",
          ""
        );
      }

      // Handle postcode
      if (value.postal_code != null) {
        setDisable((prev) => ({
          ...prev,
          postcode: true,
        }));
        formRef.current.setFieldValue(
          "certifiedOrganizationPostcode",
          value.postal_code
        );
      } else {
        setDisable((prev) => ({
          ...prev,
          postcode: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationPostcode", "");
      }

      // Handle town
      if (value.city != null) {
        setDisable((prev) => ({
          ...prev,
          town: true,
        }));
        formRef.current.setFieldValue("certifiedOrganizationTown", value.city);
      } else {
        setDisable((prev) => ({
          ...prev,
          town: false,
        }));
        formRef.current.setFieldValue("certifiedOrganizationTown", "");
      }

      setVisible((prev) => ({
        ...prev,
        certifiedOrganizationTEId: false,
      }));
    }
  };

  const formConfig = {
    pageName: "",
    initialValues,
    validationSchema: Yup.object().shape({
      certifiedOrganizationTeId: Yup.string().required("TE-ID is required"),
      certifiedOrganizationName: Yup.string().required("Name is required"),
      certifiedOrganizationLicenseNo: Yup.string().required(
        "Client No. of certified organization is required"
      ),
      certifiedOrganizationNativeName: Yup.string().nullable(),
      certifiedOrganizationAddress1: Yup.string().required(
        "Address is required"
      ),
      certifiedOrganizationTown: Yup.string().nullable(),
      certifiedOrganizationPostcode: Yup.string().nullable(),
      certifiedOrganizationCountryOrArea: Yup.string().required(
        "Country/Area is required"
      ),
      certifiedOrganizationStateOrProvince: Yup.string().required(
        "State/Province is required"
      ),
      certifiedOrganizationWebsite: Yup.string()
        .nullable()
        .matches(
          /^(?:(?:(?:https?:)?\/\/)?)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/,
          "Please enter a valid website URL"
        ),
      certifiedOrganizationEmail: Yup.array()
        .nullable()
        .of(
          Yup.string()
            .email("Please enter a valid email address")
            .matches(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              "Please enter a valid email address"
            )
        ),
      certifiedOrganizationContactLastName: Yup.string().nullable(),
      certifiedOrganizationPublicEmail: Yup.string(),
    }),
    readOnly: hasSubmitSC,
    sections: [
      {
        title: "Certified Organization Details",
        fields: [
          {
            label: "TE-ID",
            name: "certifiedOrganizationTeId",
            type: "search",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: initialValues.certifiedOrganizationTeId,
            visible: (value: any) => visible.certifiedOrganizationTEId,
            props: {
              placeholder: "Search TE-ID",
              variant: "outlined",
              param: "certifiedOrganizationTeId",
              restrictInputFormat: visible.coTEIdLabel,
              onChange: handleSellerTEIdValueChange,
              displayKey: "TE_ID",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "TE-ID",
            name: "certifiedOrganizationTeId",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            // value: 'initialValues.sellerAddress1',
            // disabled: (values: any) => disable.address1,
            visible: (value: any) => !visible.certifiedOrganizationTEId,
            props: {
              placeholder: "Enter TE-ID",
              fullWidth: true,
            },
          },
          {
            label: "Name",
            name: "certifiedOrganizationName",
            type: "search",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: initialValues.certifiedOrganizationName,
            visible: (value: any) => visible.certifiedOrganizationName,
            props: {
              placeholder: "Search Name",
              variant: "outlined",
              param: "certifiedOrganizationName",
              onChange: handleSellerNameValueChange,
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Name",
            name: "certifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            disabled: true,
            visible: (value: any) => !visible.certifiedOrganizationName,
            props: {
              placeholder: "Enter Name",
              fullWidth: true,
            },
          },
          {
            label: "Address",
            name: "certifiedOrganizationAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: initialValues.certifiedOrganizationAddress1,
            // disabled: true,
            disabled: (values: any) => disable.address1,
            props: { placeholder: "Enter Address Line 1" },
          },
          {
            label: "Town",
            name: "certifiedOrganizationTown",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: initialValues?.certifiedOrganizationTown,
            disabled: disable?.town,
            props: { placeholder: "Enter Town" },
          },
          {
            label: "Postcode",
            name: "certifiedOrganizationPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: initialValues.certifiedOrganizationPostcode,
            disabled: disable?.postcode,
            props: { placeholder: "Enter Postcode" },
          },
          {
            label: "Country/Area",
            name: "certifiedOrganizationCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: initialValues.certifiedOrganizationCountryOrArea,
            disabled: disable?.country,
            events: {
              onChange: (newValue: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode);
              },
            },
            props: {
              enableSearch: true,
              options: countryOptions,
              placeholder: "Select Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "State/Province",
            name: "certifiedOrganizationStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: initialValues.certifiedOrganizationStateOrProvince,
            disabled: (values: any) => disable.state,
            props: {
              options: stateOptions,
              enableSearch: true,
              placeholder: "Select State/Province",
              fullWidth: true,
              loading: isLoadingStates,
            },
          },
          {
            label: "Client Number of certified organization",
            name: "certifiedOrganizationLicenseNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            props: {
              placeholder: "Enter Client Number of certified organization",
            },
          },
          {
            label: "Native Name",
            name: "certifiedOrganizationNameNative",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: { placeholder: "Enter Native Name" },
          },
          {
            label: "Contact Person First Name",
            name: "certifiedOrganizationContactFirstName",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: { placeholder: "Enter Contact Person First Name" },
          },
          {
            label: "Contact Person Last Name",
            name: "certifiedOrganizationContactLastName",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: { placeholder: "Enter Contact Person Last Name" },
          },
          {
            label: "Website",
            name: "certifiedOrganizationWebsite",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: { placeholder: "Enter Website" },
          },
          {
            label: "Public Email",
            name: "certifiedOrganizationEmail",
            type: "chips",
            gridSize: { xs: 12, md: 12, lg: 12 },
            required: false,
            props: {
              placeholder: "Enter Email",
              fullWidth: true,
            },
          },
          {
            label: "Display Certified org public email on Public Listing",
            name: "certifiedOrganizationPublicEmail",
            type: "radio",
            gridSize: { xs: 12, md: 12, lg: 12 }, // Changed to full width
            required: false,
            value: initialValues.certifiedOrganizationPublicEmail,
            props: {
              options: [
                { value: "Y", label: "Yes" },
                { value: "N", label: "No" },
              ],
            },
          },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      try {
        if (SC_ID) {
          setLoadingState(true);
          const payload = mapPayload(
            values,
            SC_ID,
            countryOptions,
            stateOptions
          );
          const result: any = await executePost(API_ROUTES.CO_DETAILS, payload);
          if (result.status == 200) {
            notify("Saved Succesfully", "success");
            await onNextTab();
            navigate(`/sc/${formtype}/facility-details/${SC_ID}`);
          } else {
            notify("Unable to Save", "error");
            setLoadingState(false);
          }
        }
      } catch (error) {
        setLoadingState(false);
        console.error("Error saving Certified Organization Details:", error);
      }
    },
  };

  // Handle form submission outside of FormBuilder
  const handleSubmit = () => {
    Utills.cl(formRef.current);

    if (formRef.current) {
      formRef.current.submitForm(); // Programmatically submit the form
    }
  };

  const handleNavigateToNextTab = () => {
    navigate(`/sc/${formtype}/facility-details/${SC_ID}`);
  };

  return (
    <Box>
      {/* Render the FormBuilder component and pass formRef and onSubmit handler */}
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <FormBuilder
            formConfig={formConfig}
            onSubmit={formConfig.handleSubmit}
            formRef={formRef}
          />

          {/* Submit button outside the FormBuilder */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <NavLink to="/sc-dashboard">
              <StyledButton sx={{ boxShadow: "none" }}>
                Home
              </StyledButton>
            </NavLink>
            <StyledButton
              variant="contained"
              sx={{ boxShadow: "none" }}
              onClick={hasSubmitSC ? handleNavigateToNextTab : handleSubmit}
            >
              {hasSubmitSC ? "Next" : "Save & Next"}
            </StyledButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default CertifiedOrganizationDetails;
